import PlateShow from '@/common/components/base/plateShow/PlateShow';
import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import { getBodyVehicleInformationOption } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleInformation/getBodyVehicleInformationOption';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
export default () => {
  return (
    <MainLayout title={'بیمه گذار / مشخصات وسیله‌نقلیه'} header="titleHeader">
      <BodyShowVehicleInformation />
    </MainLayout>
  );
};
const BodyShowVehicleInformation = () => {
  const { id } = useParams();
  const { data } = useQuery(getBodyVehicleInformationOption({ id: +id! }));
  const showData = [
    { label: 'نوع وسیله‌نقلیه', value: data?.vehicle_type?.fa_name! },
    { label: 'سیستم و تیپ', value: data?.vehicle_model?.name! },
    { label: 'مورد استفاده', value: data?.vehicle_use?.name! },
    { label: 'نوع پلاک', value: data?.vehicle_plate_type?.name! },
    { label: 'نمونه پلاک', value: data?.vehicle_plate_sample?.title! },
    { label: 'طرح پلاک', value: data?.vehicle_plate_design?.fa_const! },
    {
      label: 'پلاک',
      value: (
        <PlateShow
          plateData={{
            vehicle_plate: data?.vehicle_plate,
            vehicle_plate_bottom: data?.vehicle_plate_bottom,
            vehicle_plate_iran: data?.vehicle_plate_iran,
            vehicle_plate_left: data?.vehicle_plate_left,
            vehicle_plate_letter: data?.vehicle_plate_letter,
            vehicle_plate_right: data?.vehicle_plate_right,
            vehicle_plate_top: data?.vehicle_plate_top,
          }}
          vehicleDesign={data?.vehicle_plate_design?.const!}
          vehicleType={data?.vehicle_type?.const!}
        />
      ),
    },
    { label: 'سال ساخت', value: data?.vehicle_manufacturing_year! },
    { label: 'رنگ وسیله‌نقلیه', value: data?.vehicle_color?.name! },
    { label: 'شماره VIN', value: data?.vehicle_vin! },
    { label: 'شماره شاسی', value: data?.vehicle_chassis! },
    { label: 'شماره موتور', value: data?.vehicle_engine! },
    { label: 'درصد تقصیر', value: data?.fault_percentage?.toString()! },
    {
      label: 'ارزش روز وسیله‌نقلیه (ریال)',
      value: data?.vehicle_price?.toString()!,
    },
  ];
  return (
    <Box
      className={css({
        paddingTop: '24px',
        paddingBottom: '24px',
      })}
    >
      <ShowIncidentParticipantsDataCard
        data={showData}
        title="اطلاعات وسیله‌نقلیه"
      />
    </Box>
  );
};
